module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Ver":"Ver","Ver todos":"Ver todos","No hay artículos que mostrar!":"No hay artículos que mostrar!"},"en":{},"ca":{"Ver":"Veure","Ver todos":"Veure tots","No hay artículos que mostrar!":"No ho hi ha articles per mostrar!"}}')
  delete Component.options._Ctor
}
